import { HelpModule } from './types';

/**
 * A tanuló mód és a Súgó oldal tartalma - minden modul egy helyen.
 *
 * Új modulnál vagy új gombnál ide kerül a leírás (lásd a help-docs skillt).
 * A sorrend a menü sorrendjét követi, mert a Súgó oldal is így listáz.
 */
export const helpModules: HelpModule[] = [
  {
    id: 'dashboard',
    gif: '/help/dashboard.gif',
    forGuests: true,
    title: 'Áttekintő',
    paths: ['/'],
    audience: 'all',
    summary:
      'A kezdőlap: egy pillantással látod, mi vár rád ma és a következő napokban, és mi igényel figyelmet.',
    steps: [
      'A „Közelgő események” a következő két hét programja napok szerint; egy kártyára kattintva megnyílik az esemény a részletekkel, a visszajelzésekkel és az utazással.',
      'A „Teendők” csak akkor jelenik meg, ha van dolgod: kintlévőség, lejárt vagy lejáró sportorvosi, beteg/sérült játékosok, új jelentkező, jóváhagyásra váró foglalás. Egy kattintással a megfelelő helyre visz, vagy megmutatja, kik azok.',
      'Alatta az üzenőfal legutóbbi bejegyzései.',
    ],
  },
  {
    id: 'calendar',
    gif: '/help/calendar.gif',
    forGuests: true,
    title: 'Naptár',
    paths: ['/calendar'],
    audience: 'all',
    summary: 'A klub összes eseménye naptárnézetben: edzések, mérkőzések, egyéb programok és pályafoglalások.',
    steps: [
      'Válts a havi, heti, napi vagy lista nézet között aszerint, mennyire részletesen szeretnéd látni.',
      'Kattints egy eseményre a részletekért, a visszajelzéshez vagy - edzőként - a szerkesztéshez.',
      'Edzőként egy üres napra kattintva új eseményt hozhatsz létre arra a napra.',
    ],
    tips: [
      'A Profil oldalon találsz egy naptár feed linket: ezzel a saját telefonos naptáradba (Google, Apple) is behúzhatod az eseményeket.',
    ],
  },
  {
    id: 'events',
    gif: '/help/events.gif',
    title: 'Események',
    paths: ['/events'],
    audience: 'all',
    summary:
      'Edzések, mérkőzések és egyéb klubprogramok listája. Itt jelzel vissza, hogy ott leszel-e, és itt látod, ki jön.',
    steps: [
      'Szűrd a listát típus és korosztály szerint a Szűrők panelen.',
      'Egy eseményre kattintva megnyílik a részletes nézet: helyszín, időpont, pálya, résztvevők, hozzászólások.',
      'A visszajelző gombokkal jelezd, hogy jössz-e. Edzőként itt látod a teljes névsort és a hiányzókat.',
      'Edzőként az „Új esemény” gombbal hozhatsz létre eseményt; mérkőzés típusnál a mérkőzés rekord automatikusan létrejön.',
      'Az „Ismétlődik” jelöléssel (pl. hetente, a megadott végdátumig, legfeljebb 6 hónapra) minden alkalom külön esemény lesz, saját visszajelzéssel.',
      'Az „Utazást is szervezünk” jelöléssel már létrehozáskor megadhatod a járműveket és a megállókat (indulási idővel); ismétlődésnél minden alkalomra. Ki kivel megy, azt később az esemény „Utazás szerkesztése” gombjával osztod be.',
    ],
    tips: [
      'Eseménynél beállíthatsz emlékeztetőt: a résztvevők push értesítést kapnak a kezdés előtt.',
      'Pályát vizuálisan, pályarészre bontva lehet foglalni - így látszik, ha valaki már használja a pálya felét.',
    ],
    items: [
      {
        id: 'filters',
        label: 'Szűrők',
        text: 'Típus és korosztály szerint szűkítheted a listát.',
      },
      {
        id: 'response',
        label: 'Visszajelzés',
        text: 'Jelezd, hogy ott leszel-e. Az edző ez alapján tervez - ha változik, bármikor módosíthatod.',
      },
    ],
  },
  {
    id: 'matches',
    gif: '/help/matches.gif',
    title: 'Mérkőzések',
    paths: ['/matches'],
    audience: 'all',
    summary: 'Az összes mérkőzés eredményekkel, kezdőcsapattal és játékos statisztikával.',
    steps: [
      'Szűrj korosztályra vagy dátumra, és válassz ki egy mérkőzést a listából.',
      'Edzőként a felállás szerkesztőben válassz formációt, és húzd a játékosokat a pályára; a cserék a kispadra kerülnek.',
      'A mérkőzés után rögzítsd az eredményt és a játékosok góljait, gólpasszait, lapjait és perceit.',
    ],
    tips: [
      'A gyakran használt felállásokat elmentheted, és a következő meccsnél egy kattintással betöltheted.',
      'A mezszámokat a rendszer a korábbi meccsek alapján javasolja.',
      'Futsal meccsnél pipáld be a mérkőzés ablak tetején a „Futsal” jelölőt: a felállás szerkesztő így 4+1 fővel nyílik meg, nem 11-gyel.',
    ],
    items: [
      {
        id: 'aiSummary',
        label: 'Beszámoló',
        text: 'Az AI a rögzített eredményből, a kezdőcsapatból és a gólszerzőkből beszámolót ír - az üzenőfalra, a szülőknek vagy a klub Facebook-oldalára. Megadhatod, hogy teljes névvel, keresztnévvel vagy nevek nélkül írjon. Csak akkor látszik, ha az admin bekapcsolta az AI funkciókat.',
      },
    ],
  },
  {
    id: 'statistics',
    gif: '/help/statistics.gif',
    title: 'Mérkőzés statisztika',
    paths: ['/statistics'],
    audience: 'all',
    summary: 'A játékosok mérkőzésen nyújtott teljesítménye összesítve: meccsek, percek, gólok, gólpasszok, lapok.',
    steps: [
      'Válassz korosztályt és időszakot a szűrőkben.',
      'Az oszlopfejlécre kattintva rendezheted a táblázatot, pl. góllövők szerint.',
    ],
  },
  {
    id: 'drills',
    gif: '/help/drills.gif',
    title: 'Gyakorlattár',
    paths: ['/drills'],
    audience: 'staff',
    summary: 'A klub közös gyakorlat-gyűjteménye rajzzal és leírással, valamint az újrahasználható edzéstervsablonok.',
    steps: [
      'Keress név vagy leírás alapján, vagy böngéssz a listában.',
      'Új gyakorlatnál a rajztáblán megrajzolhatod a felállást, a mozgásokat és a labdautat.',
      'A Sablonok fülön teljes edzésterveket menthetsz, amiket később egy edzéshez egy kattintással hozzárendelhetsz.',
    ],
    items: [
      {
        id: 'aiDiagram',
        label: 'Rajz AI-val',
        text: 'Az AI a Leírás (és a létszám, eszközök) alapján megrajzolja a gyakorlatot a rajztáblán. Utána a rajzra kattintva tovább igazíthatod. Csak akkor látszik, ha az admin bekapcsolta az AI funkciókat.',
      },
    ],
  },
  {
    id: 'training-statistics',
    gif: '/help/training-statistics.gif',
    title: 'Edzés statisztika',
    paths: ['/training-statistics'],
    audience: 'all',
    summary: 'Ki hány edzésen vett részt, és mikor volt utoljára - az edzéslátogatottság áttekintése.',
    steps: [
      'Válassz korosztályt és időszakot.',
      'A táblázatból kiderül, ki jár rendszeresen és ki hiányzik sokat.',
    ],
  },
  {
    id: 'trainings',
    gif: '/help/trainings.gif',
    title: 'Edzések',
    paths: ['/trainings'],
    audience: 'all',
    summary: 'Az edzések részletei: jelenlét, edzésterv és a játékosok visszajelzése az edzésről.',
    steps: [
      'Nyiss meg egy edzést, és az edzés végén rögzítsd, ki volt jelen.',
      'Az Edzésterv részben blokkokba rendezheted a gyakorlatokat, akár a Gyakorlattárból vagy sablonból.',
      'Ha be van kapcsolva, a játékosok az edzés után értékelhetik, milyen volt.',
    ],
    items: [
      {
        id: 'aiPlan',
        label: 'Terv AI-val',
        text: 'Add meg a témát (pl. „Labdakihozatal hátulról”), az időtartamot és a létszámot: az AI bemelegítéstől levezetésig összerak egy tervet, és ahol illik, a klub gyakorlattárából választ (a rajzokkal együtt). A blokkoknál a „Rajz AI-val” a leírásból rajzot készít. Csak akkor látszik, ha az admin bekapcsolta az AI funkciókat.',
      },
    ],
  },
  {
    id: 'travel',
    gif: '/help/travel.gif',
    title: 'Utazások',
    paths: ['/travel'],
    audience: 'all',
    summary:
      'Utazásszervezés mérkőzésekre, tornákra és edzésekre: ki melyik autóval vagy busszal megy, hol száll fel, kinek kell még fuvar.',
    steps: [
      'Szülőként amikor jelzed, hogy a gyereked jön, rögtön alatta megadhatod, hogyan jut el: „Fuvar kell” (és ha már van busz vagy autó, hol száll be), vagy „Saját maga megy”.',
      'Ha „Saját maga megy”, és viszed is, jelöld be a „Tudok vinni valakit” lehetőséget: megadhatod, hány gyerek fér be; utána a „Kit viszel még?” listából a csapatból bárkit beültethetsz, akiről még nem döntöttek.',
      'Edzőként az Utazások oldalon minden közelgő eseményt látsz (edzést, meccset, egyebet), típus szerint szűrhetően.',
      'Edzőként az „Utazás szervezése” gombbal veszed fel a járműveket és a megállókat, és osztod be az utasokat; a szülők jelzései és felajánlott autói itt is látszanak.',
      'A heti edzésekre járó kisbusznál elég egyszer beállítani: a „Másolás más eseményekre” gombbal átviheted a következő edzésekre, vagy a szerkesztőben átveheted egy korábbi eseményből.',
    ],
    tips: [
      'Ha a gyereket beosztják egy autóba vagy megállóhoz, vagy áthelyezik, a gyerek és a szülei push értesítést kapnak - csak a mentés után, nem minden kattintásnál.',
      'Kerettel rendelkező mérkőzésnél az utazást csak a keret tagjainak családja látja, és csak ők jelezhetnek; keret nélkül mindenki. Ha később lesz keret, onnantól ez érvényes.',
      'Ha egy szülő kiveszi a gyerekét az edző által beosztott járműből, erről az esemény edzője értesítést kap.',
      'Aki „Nem jön” visszajelzést ad, annak a helye magától felszabadul az utazásban.',
    ],
  },
  {
    id: 'ai',
    title: 'AI asszisztens',
    paths: ['/ai'],
    audience: 'staff',
    summary:
      'Kérdezz a klub adataira hétköznapi nyelven, és kérj heti összefoglalót a csapatodról. Csak akkor látszik, ha az admin bekapcsolta az AI funkciókat.',
    steps: [
      'A „Kérdezz az adatokról” mezőbe írd be a kérdésed (pl. „Kinek jár le a sportorvosija a következő 30 napban?”), vagy kattints egy példára. A válasz egy táblázat.',
      'A „Heti összefoglaló” részben válaszd ki a korosztályt és az időszakot, majd kattints az „Összefoglaló készítése” gombra: az AI kiemeli, kire figyelj, kit dicsérj, és javaslatot tesz a jövő hétre.',
      'Az összefoglalót a „Másolás” gombbal továbbküldheted a stábnak.',
    ],
    tips: [
      'A kérdéseknél az AI csak a kérdést látja, az adatokat nem: a választ a Portero a te jogosultságaiddal keresi ki, így csak a saját korosztályaid játékosai jelennek meg.',
      'Az oldal tetején látod, hány AI kérésed maradt még mára.',
    ],
    items: [
      {
        id: 'ask',
        label: 'Kérdezz az adatokról',
        text: 'Játékpercek, góllövők, edzéslátogatás, sportorvosi lejárat, születésnapok, távollévők, tartozások és közelgő események - korosztályra és időszakra szűrve.',
      },
      {
        id: 'weekly',
        label: 'Heti összefoglaló',
        text: 'A részvételből, a játékosok terheléséből (RPE), a visszajelzésekből és a távollétekből összefoglaló a hétről, a figyelmet érdemlő játékosokkal és javaslatokkal a jövő hétre.',
      },
    ],
  },
  {
    id: 'board',
    forFamily: true,
    gif: '/help/board.gif',
    forGuests: true,
    title: 'Üzenőfal',
    paths: ['/board'],
    audience: 'all',
    summary: 'Gyors közlemények a klubnak vagy egy-egy korosztálynak - ami nem elég fontos egy eseményhez, de mindenkinek tudnia kell.',
    steps: [
      'Olvasd el az új bejegyzéseket - a menüben a szám mutatja, hány olvasatlan van.',
      'Ha jogosult vagy, az „Új bejegyzés” gombbal írhatsz; válaszd ki, mely korosztályok (vagy a vendégek) lássák.',
      'Egy bejegyzés eseményhez is köthető („Eseményhez kapcsolódik?”): ilyenkor az esemény oldalán is megjelenik, a bejegyzésből pedig egy kattintással az eseményhez jutsz. Az esemény oldalán a „Bejegyzés ehhez az eseményhez” gombbal rögtön oda köthetsz egyet.',
      'A bejegyzésekhez hozzá lehet szólni, ha a klub beállításai engedik.',
    ],
    items: [
      {
        id: 'aiWriter',
        label: 'Megírás AI-val',
        text: 'Írd le kulcsszavakban, mit kell közölni (pl. „szombat 9:00, Debrecen, gyülekező 7:30”), válassz hangnemet, és az AI kész bejelentést ír. Ha eseményt is választasz, annak időpontját és helyszínét is beleírja. Kulcsszavak nélkül a már beírt szöveget fogalmazza át. Edzőknek és adminoknak, ha az AI be van kapcsolva.',
      },
    ],
  },
  {
    id: 'players',
    gif: '/help/players.gif',
    title: 'Játékosok',
    paths: ['/players'],
    audience: 'staff',
    summary: 'A klub játékosainak nyilvántartása: személyes adatok, kapcsolattartók, sportorvosi, IFA kód, távollétek.',
    steps: [
      'Keress név, TAJ szám vagy IFA kód alapján (ékezet nélkül is), vagy szűrj korosztályra.',
      'A gyorsszűrőkkel („Lejárt sportorvosi”, „Hamarosan lejár”, „Nincs IFA-kód”…) egy kattintással azokat látod, akikkel teendő van; az oszlopfejlécre kattintva rendezhetsz.',
      'Egy játékosra kattintva megnyílik az adatlapja: kapcsolattartók, iskola, dokumentumok, távollétek.',
      'Új játékost egyenként, Excelből importálva vagy az IFA-ból is felvehetsz; a szülőket tömegesen is meghívhatod.',
    ],
    tips: [
      'A piros/sárga sportorvosi jelzés a lejárt, illetve hamarosan lejáró érvényességet mutatja.',
      'Egy helyben felvett játékost az „Összekötés IFA-val” gombbal párosíthatsz az MLSZ nyilvántartással.',
      'A „Sportorvosi ellenőrzés” ablakban a kijelölt játékosok dátuma az IFA-ból frissíthető - azoké is, akiknek még érvényes, de már elmentek az új vizsgálatra.',
    ],
    items: [
      {
        id: 'search',
        label: 'Keresés',
        text: 'Név, TAJ szám vagy IFA kód részletére is keres.',
      },
      {
        id: 'aiEvaluation',
        label: 'Értékelés AI-val',
        text: 'A játékos adatlapján: az edzéslátogatásból, a mérkőzésstatisztikából és a megfigyeléseidből fejlődési értékelés vázlatát írja a szülőknek vagy a stábnak. Az AI a játékos nevét nem látja.',
      },
      {
        id: 'aiExtract',
        label: 'Kitöltés dokumentumból',
        text: 'Új játékos felvételénél: töltsd fel a kitöltött jelentkezési lap fotóját, vagy illeszd be egy email szövegét, és az AI kitölti az űrlapot. Mentés előtt ellenőrizd a mezőket. Csak adminnak, és csak ha a Rendszerbeállításokban engedélyezték.',
      },
    ],
  },
  {
    id: 'applications',
    gif: '/help/applications.gif',
    title: 'Jelentkezések',
    paths: ['/applications'],
    audience: 'admin',
    summary: 'Új játékosok jelentkezései a nyilvános jelentkezési űrlapról.',
    steps: [
      'A Rendszerbeállításokban add meg az adatkezelési tájékoztatót, és kapcsold be a nyilvános jelentkezési űrlapot - tájékoztató nélkül nem kapcsolható be.',
      'Másold ki a jelentkezési linket, és oszd meg a szülőkkel (weboldal, Facebook, plakát).',
      'Nézd át a beérkező jelentkezést, válaszd ki, melyik korosztályba kerüljön, és fogadd el vagy utasítsd el indoklással.',
      'Elfogadáskor a játékos bekerül a nyilvántartásba, a szülő értesítést kap.',
    ],
  },
  {
    id: 'schools',
    gif: '/help/schools.gif',
    title: 'Iskolák',
    paths: ['/schools'],
    audience: 'admin',
    summary: 'A játékosok iskolái és kapcsolattartói - ide mennek a kikérők és igazolások.',
    steps: [
      'Vedd fel az iskolát a címével és a kapcsolattartóval (pl. igazgatóhelyettes, titkárság).',
      'A játékos adatlapján rendeld hozzá az iskolát.',
      'Egy dokumentumot (pl. kikérőt) közvetlenül elküldhetsz az érintett iskoláknak emailben.',
    ],
  },
  {
    id: 'age-groups',
    gif: '/help/age-groups.gif',
    title: 'Korosztályok',
    paths: ['/age-groups'],
    audience: 'admin',
    summary: 'A klub csapatai/korosztályai, a hozzájuk tartozó edzőkkel és játékosokkal.',
    steps: [
      'Hozz létre korosztályt névvel és születési év tartománnyal.',
      'Rendeld hozzá az edzőket és - akár tömegesen - a játékosokat.',
    ],
    tips: ['A korosztály határozza meg, ki milyen eseményeket, mérkőzéseket és bejegyzéseket lát.'],
  },
  {
    id: 'membership-fees',
    forFamily: true,
    gif: '/help/membership-fees.gif',
    title: 'Tagdíjak',
    paths: ['/membership-fees'],
    audience: 'all',
    summary: 'A havi tagdíjak nyilvántartása: ki fizetett, ki tartozik, mennyi a kintlévőség.',
    steps: [
      'Adminként a „Tagdíjak generálása” gombbal hozd létre a havi díjakat: válaszd ki a hónapot, hogy az egész klubnak, egyes korosztályoknak vagy kiválasztott játékosoknak, és mekkora összeggel. Az előnézet mutatja, kinek mennyi készül; 0 Ft-os tagdíj nem jön létre.',
      'Válaszd ki a hónapot, szűrj korosztályra vagy státuszra, és jelöld a befizetéseket.',
      'Több befizetést egyszerre is jelölhetsz: pipáld ki őket (vagy a fejlécben az összes szűrtet), majd az alul megjelenő sávon nyomd meg a „Fizetve” gombot.',
      'A „Beállítások” részen add meg az alapdíjat; egy-egy játékosnak egyedi díjat is adhatsz (pl. testvérkedvezmény).',
      'A kintlévőség panelt lenyitva egy-egy tartozónak, vagy az „Emlékeztető küldése...” gombbal mindenkinek, egyes korosztályoknak vagy kiválasztott játékosoknak küldhetsz emlékeztetőt, push értesítésben és/vagy emailben; a Beállításokban havi automatikus emlékeztető is bekapcsolható.',
      'Szülőként itt látod a gyereked befizetéseit és tartozását.',
    ],
  },
  {
    id: 'documents',
    forFamily: true,
    gif: '/help/documents.gif',
    title: 'Dokumentumok',
    paths: ['/documents'],
    audience: 'all',
    summary: 'Megosztott fájlok: szabályzatok, nyomtatványok, játékosokhoz és eseményekhez csatolt dokumentumok.',
    steps: [
      'Böngéssz a fülek között: Közös, Stáb, Játékosok - szülőként a Saját dokumentumaim fülön a gyereked dokumentumait látod.',
      'A „Dokumentum feltöltése” gombbal tölts fel új fájlt, és add meg, kik láthatják.',
    ],
  },
  {
    id: 'messages',
    gif: '/help/messages.gif',
    title: 'Üzenetek',
    paths: ['/messages'],
    audience: 'all',
    summary: 'Közvetlen üzenetváltás a klub tagjaival - szülő és edző, edző és edző között.',
    steps: [
      'Válassz egy beszélgetést bal oldalt, vagy keress rá egy névre.',
      'Írd be az üzenetet alul, és küldd el. A „Olvasva” jelzés mutatja, ha a címzett már látta.',
    ],
  },
  {
    id: 'venues',
    gif: '/help/venues.gif',
    title: 'Pályák',
    paths: ['/venues'],
    audience: 'admin',
    summary: 'A klub által használt pályák és helyszínek adatai.',
    steps: [
      'Vedd fel a pályát névvel, címmel és típussal.',
      'Add meg, hány részre osztható (pl. fél pálya, negyed pálya) - így pályarészre is lehet foglalni.',
      'A részeket el is nevezheted (pl. „Kapu felőli”, „Öltöző felőli”): a foglalásnál, a foglaltságnál és az eseményeknél ez a név látszik.',
    ],
  },
  {
    id: 'venue-occupancy',
    gif: '/help/venue-occupancy.gif',
    title: 'Pálya foglaltság',
    paths: ['/venue-occupancy'],
    audience: 'staff',
    summary: 'Melyik pálya melyik része mikor foglalt, és mikor szabad - napra vagy hétre.',
    steps: [
      'Fent válaszd ki a pályát, a hétsávban a napot (a pöttyök a foglalások számát jelzik), jobbra a „Nap” vagy „Hét” nézetet.',
      'Asztalon a napi nézet pályarészenként mutatja az idővonalat, a heti hét oszlopban; telefonon időrendi lista a szabad sávokkal.',
      'Egy foglalásra kattintva látod, ki, mikor és melyik részt foglalja; eseménynél onnan meg is nyithatod.',
      'Foglalni a „Foglalás” gombbal, egy szabad sáv „Foglalás” gombjával, vagy asztalon egy üres időpontra kattintva lehet.',
    ],
  },
  {
    id: 'bookings',
    gif: '/help/bookings.gif',
    forGuests: true,
    title: 'Foglalások',
    paths: ['/bookings'],
    audience: 'all',
    summary: 'Pályafoglalási kérelmek. Vendégként itt kérsz pályát, adminként itt hagyod jóvá vagy utasítod el.',
    steps: [
      'Vendégként add meg a pályát, időpontot és pályarészt - a kérelem jóváhagyásra vár.',
      'Adminként nézd át a függő kérelmeket, és hagyd jóvá vagy utasítsd el indoklással.',
    ],
  },
  {
    id: 'users',
    gif: '/help/users.gif',
    title: 'Felhasználók',
    paths: ['/users'],
    audience: 'admin',
    summary: 'A rendszer felhasználói és szerepköreik (admin, edző, játékos, szülő, vendég).',
    steps: [
      'Hívj meg új felhasználót emailben; a meghívott a linken állítja be a jelszavát. Ez az ajánlott mód.',
      'Az „Új felhasználó” gombbal jelszóval is létrehozhatsz fiókot; a „Jelszóbeállító link küldése emailben” jelölővel a felhasználó egy 7 napig érvényes linket kap. A jelszót soha nem küldjük el emailben.',
      'Sok felhasználónál keress név vagy email szerint, vagy szűrj szerepkörre (pl. csak a szülők).',
      'Egy felhasználónak több szerepköre is lehet (pl. edző és szülő egyszerre) - a jelölőnégyzetekkel állítsd be.',
      'Edzőnél add meg a korosztályait, szülőnél a gyerekeit.',
    ],
  },
  {
    id: 'registrations',
    gif: '/help/registrations.gif',
    title: 'Regisztrációk',
    paths: ['/registrations'],
    audience: 'admin',
    summary: 'Önregisztrációs kérelmek - akik maguk regisztráltak, és jóváhagyásra várnak.',
    steps: [
      'Nézd meg, ki és milyen megjegyzéssel regisztrált.',
      'Válassz legalább egy szerepkört, kapcsold össze a megfelelő játékossal, és hagyd jóvá.',
    ],
  },
  {
    id: 'email-log',
    gif: '/help/email-log.gif',
    title: 'Email napló',
    paths: ['/email-log'],
    audience: 'admin',
    summary: 'A rendszer által kiküldött emailek listája - ha valaki azt mondja, nem kapott levelet, itt ellenőrizheted.',
    steps: ['Keress címzettre vagy tárgyra, és szűrj típus szerint.'],
  },
  {
    id: 'ifa',
    gif: '/help/ifa.gif',
    title: 'IFA',
    paths: ['/ifa'],
    audience: 'admin',
    summary: 'Kapcsolat az MLSZ IFA rendszerével: játékosok importálása és a sportorvosi dátumok frissítése.',
    steps: [
      'Jelentkezz be: ha a Profilban elmentetted az IFA belépésed, elég a „Bejelentkezés és lekérdezés” gomb; különben add meg itt, és el is mentheted.',
      'Válaszd ki az egyesületet, és keresd meg a játékosokat.',
      'Jelöld ki az importálandókat, vagy frissítsd a meglévők sportorvosi érvényességét.',
    ],
  },
  {
    id: 'club-settings',
    gif: '/help/club-settings.gif',
    title: 'Testreszabás',
    paths: ['/club-settings'],
    audience: 'admin',
    summary: 'A klub arculata és alapbeállításai: név, címer, színek, MLSZ egyesület, alapértelmezett emlékeztetők.',
    steps: [
      'Add meg a klub nevét, és töltsd fel a címert (PNG vagy JPG, max. 2 MB).',
      'Válassz színpalettát - az előnézet mutatja, hogyan fog kinézni.',
      'Állítsd be az esemény értesítések alapértelmezett emlékeztetőit.',
    ],
  },
  {
    id: 'system-settings',
    gif: '/help/system-settings.gif',
    title: 'Rendszerbeállítások',
    paths: ['/system-settings'],
    audience: 'admin',
    summary: 'A klub működését befolyásoló kapcsolók: tagdíjkezelés, nyilvános jelentkezés, vendégfoglalás, üzenőfal jogok, AI asszisztens.',
    steps: [
      'Kapcsold be vagy ki a modulokat, amiket a klub használ (pl. tagdíj, edzés utáni visszajelzés).',
      'A nyilvános jelentkezési űrlap csak adatkezelési tájékoztatóval kapcsolható be: előbb írd be és mentsd el a szöveget, utána kapcsold be az űrlapot.',
      'Állítsd be, ki tehet közzé és ki szólhat hozzá az üzenőfalon.',
      'Add meg, hány nappal a lejárat előtt figyelmeztessen a rendszer a sportorvosira.',
      'Az „AI asszisztens” részben válassz modellt, állítsd be a napi korlátot, kapcsold be az „AI funkciók bekapcsolása” jelölőt, és mentsd el. A „Kapcsolat kipróbálása” gombbal ellenőrizheted, hogy működik.',
    ],
    tips: [
      'Az AI-hoz egy OpenRouter API kulcs kell a szerver beállításaiban (OpenRouter:ApiKey). Ha hiányzik, az oldal figyelmeztet.',
      'Az ingyenes modelleknek napi és percenkénti korlátjuk van; ha gyakran kapsz „túlterhelt” hibát, válassz másik modellt.',
    ],
    items: [
      {
        id: 'ai',
        label: 'AI asszisztens',
        text: 'Edzésterv, gyakorlatrajz, bejelentés, mérkőzés-beszámoló, heti összefoglaló, játékos-értékelés és kérdések az adatokról. Bekapcsolva az edzők és az adminok látják az AI gombokat. Az AI a játékosok nevét nem látja, csak jelölést, és TAJ számot, lakcímet, egészségügyi adatot nem kap - kivéve a külön engedélyezhető dokumentumból kitöltést.',
      },
      {
        id: 'aiModel',
        label: 'Modell',
        text: 'Az OpenRouter kínálatából választhatsz; a „Csak ingyenes” jelölővel a díjmentes modellek (pl. a Google Gemma ingyenes változatai) látszanak. Később bármikor átválthatsz fizetősre, ha a klub OpenRouter fiókjában van egyenleg.',
      },
    ],
  },
  {
    id: 'profile',
    gif: '/help/profile.gif',
    forGuests: true,
    title: 'Profil',
    paths: ['/profile'],
    audience: 'all',
    summary: 'A saját adataid, jelszavad, értesítési beállításaid és a naptár feed linked.',
    steps: [
      'Frissítsd a neved, email címed és telefonszámod.',
      'Szülőként a gyereked kártyáján frissítheted az elérhetőségeket, egészségügyi tudnivalókat, és bejelentheted, ha beteg vagy sérült.',
      'Kapcsold be a push értesítéseket, és válaszd ki, milyen emaileket kérsz.',
      'A naptár feed linket add hozzá a telefonod naptárához, hogy ott is lásd az eseményeket.',
    ],
  },
  // A szülők és a játékosok appja (Kezdőlap, Program, Hírek, Profil). A stáb is
  // olvashatja, hogy lássa, mit kap a szülő. A lista végén vannak, hogy egy
  // közös útvonalon (a '/') a stáb a saját modulját kapja.
  {
    id: 'family-home',
    forFamily: true,
    title: 'Kezdőlap (szülőknek, játékosoknak)',
    paths: ['/'],
    audience: 'all',
    summary: 'Egy pillantásra: mi a következő program és jön-e rá a gyereked, mi a teendőd, és mi újság a klubban.',
    steps: [
      'A legfelső kártya a következő edzés vagy meccs: a „Jön” és „Nem jön” gombbal rögtön jelezheted, hogy ott lesz-e.',
      'Ha jön, alatta rögtön megadhatod, hogyan jut el: „Fuvar kell” (hol száll be), vagy „Saját maga megy” - ha viszed, a „Tudok vinni valakit” jelöléssel másokat is vihetsz. Kikérőt is itt kérhetsz, ha jön.',
      'A „Teendők” csak akkor jelenik meg, ha van dolgod: meg nem válaszolt események, lejáró sportorvosi, fizetetlen tagdíj, elmaradó esemény.',
      'Ha a gyerek beteg vagy sérült, a „Beteg vagy sérült?” sorból jelentsd be: az érintett eseményekre magától „Nem jön” kerül.',
    ],
    tips: ['Több gyereknél mindegyiküknél külön jelezheted, hogy jön-e.'],
  },
  {
    id: 'family-program',
    forFamily: true,
    title: 'Program',
    paths: ['/program'],
    audience: 'all',
    summary: 'Az edzések, meccsek és egyéb események egy listában, napok szerint - a gyereked visszajelzésével.',
    steps: [
      'A „Közelgő” fülön a következő hetek programja, a „Korábbi” fülön a lezajlott események és a meccsek eredménye.',
      'Egy eseményre koppintva látod a helyszínt (térképpel), jelezheted, hogy jön-e, és megnézheted, kik jönnek még.',
      'Ha jelezted, hogy jön, közvetlenül alatta megadhatod az utazást is: „Fuvar kell” vagy „Saját maga megy” - ez utóbbinál a „Tudok vinni valakit” jelöléssel az autódat is felajánlhatod.',
      'Meccsnél ugyanitt látod a kezdőcsapatot és a végeredményt.',
    ],
    tips: [
      'A sor jobb szélén a pipa azt jelenti, hogy jön, az X, hogy nem, a kérdőjel, hogy még nem jelezted.',
      'Több gyereknél felül a nevükre koppintva csak az ő programjukat látod.',
    ],
  },
  {
    id: 'family-me',
    forFamily: true,
    title: 'Profil',
    paths: ['/me'],
    audience: 'all',
    summary: 'A gyereked adatlapja, tagdíj, dokumentumok, értesítések és a fiókod - minden, ami nem a programról szól.',
    steps: [
      'A gyerek nevére koppintva jelentheted be a betegséget vagy sérülést, és frissítheted az elérhetőségeket, egészségügyi adatokat.',
      'A „Tagdíj” alatt havi bontásban vagy éves összesítőben látod a befizetéseket és a hátralékot; gyerekre és állapotra is szűrhetsz. A „Dokumentumok” között az igazolásokat és a kikérőket találod.',
      'A „Fiók és értesítések” alatt kapcsolhatod be a push értesítéseket, és itt adhatod hozzá a programot a telefonod naptárához.',
    ],
  },
];

/** Az útvonalhoz tartozó modul. A '/' csak pontosan illeszkedik, a többi a mélylinkekre is. */
export const findHelpModule = (pathname: string): HelpModule | undefined =>
  helpModules.find((m) =>
    m.paths.some((p) => (p === '/' ? pathname === '/' : pathname === p || pathname.startsWith(`${p}/`)))
  );

/** Egy elem leírása `modul.elem` azonosító alapján, pl. 'events.filters'. */
export const findHelpItem = (key: string) => {
  const [moduleId, itemId] = key.split('.');
  const module = helpModules.find((m) => m.id === moduleId);
  const item = module?.items?.find((i) => i.id === itemId);
  return item ? { module, item } : undefined;
};
